module.exports = "pegasus_template/assets/blocks/tile-layout-17.png";